import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import getDecodedToken from '@/shared/utils/get-decoded-token'

export const useTokenStore = defineStore('token', () => {
  const token = ref<string>('')

  const decodedToken = computed(() => {
    return getDecodedToken(token.value)
  })

  const setToken = (tokenInconmming: string) => {
    if (tokenInconmming) {
      token.value = tokenInconmming
    } else {
      token.value = ''
    }
  }

  const getCampaign = () => {
    return decodedToken.value?.cc || ''
  }

  return {
    token,
    decodedToken,
    setToken,
    getCampaign
  }
})
